import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React from 'react';
import { RadioGroup as RadioGroup$1 } from 'react-aria-components';
import { Description } from '../Description/Description.es.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.es.js';
import { Label } from '../Label/Label.es.js';

const radioGroup = "_radio-group_k56ft_1";
const styles = {
	radioGroup: radioGroup
};

const RadioGroup = (_a) => {
  var { children, className, isRequired, label, description, errorMessage } = _a, props = __rest(_a, ["children", "className", "isRequired", "label", "description", "errorMessage"]);
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    React.createElement(
      RadioGroup$1,
      Object.assign({ className: clsx(className, styles.radioGroup), "data-zds": true }, props),
      label && React.createElement(Label, { isRequired }, label),
      children,
      description && React.createElement(Description, null, description),
      React.createElement(ErrorMessage, null, errorMessage)
    )
  );
};

export { RadioGroup };
//# sourceMappingURL=RadioGroup.es.js.map
